// Decides whether the manage header's centered chip cluster still fits on the title row.
// Pure arithmetic over measurements the host reads from the DOM.

export const MANAGE_HEADER_CHIP_STACK_HYSTERESIS = 32;

/** Measured widths/offsets of the manage header row, in CSS pixels. */
export interface ManageHeaderChipMeasurements {
  readonly headerWidth: number;
  readonly paddingLeft: number;
  readonly paddingRight: number;
  readonly columnGap: number;
  readonly chipsWidth: number;
  /** Title + tags cluster, not the grown identity flex/grid box. */
  readonly identityWidth: number;
  readonly actionsWidth: number;
}

/**
 * Centered chips sit between the identity block and the action cluster. Once stacked, the chips must
 * clear an extra `hysteresis` on both sides before returning to the row, so a ResizeObserver watching
 * the very elements this moves cannot flip-flop.
 */
export function nextManageHeaderChipsStacked(measurements: ManageHeaderChipMeasurements, currentlyStacked: boolean, hysteresis = MANAGE_HEADER_CHIP_STACK_HYSTERESIS): boolean {

  const { headerWidth, paddingLeft, paddingRight, columnGap, chipsWidth, identityWidth, actionsWidth } = measurements;
  const contentWidth = headerWidth - paddingLeft - paddingRight;
  const chipsLeft = paddingLeft + Math.max(0, contentWidth - chipsWidth) / 2;
  const chipsRight = chipsLeft + chipsWidth;
  const identityRight = paddingLeft + identityWidth;
  const actionsLeft = headerWidth - paddingRight - actionsWidth;
  const slack = currentlyStacked ? hysteresis : 0;
  const fits = chipsLeft >= identityRight + columnGap + slack && chipsRight <= actionsLeft - columnGap - slack;

  return !fits;
}
